import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const activityLogSlice = createAppSlice({
  name: 'activityLog',
  initialState,
  reducers,
});

export const { fetchActivityLog, setShowActivityLogModal } = activityLogSlice.actions;

export default activityLogSlice.reducer;
